import React, { useState } from 'react';
import './Portfolio.css';
import { FaAndroid, FaApple } from 'react-icons/fa';

const Portfolio = () => {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Clubera',
      category: 'education',
      description: 'College club management platform with events, subscriptions, AI assistant, and real-time chat',
      tech: ['Flutter', 'Provider', 'SignalR', 'Firebase', 'Razorpay'],
      playStore: 'https://play.google.com/store/apps/details?id=com.clubera',
      appStore: 'https://apps.apple.com/in/app/clubera/id6758563182',
      hasAndroid: true,
      hasIos: true
    },
    {
      id: 2,
      title: 'HMPK',
      category: 'enterprise',
      description: 'Organizational demand management with multi-level approvals, discussion threads, and AI assistance',
      tech: ['Flutter', 'Provider', 'Dio', 'Gemini AI', 'PDF'],
      playStore: 'https://play.google.com/store/apps/details?id=com.subharti.demandbooks',
      appStore: 'https://apps.apple.com/in/app/hmpk/id6743952702',
      hasAndroid: true,
      hasIos: true
    },
    {
      id: 3,
      title: 'MediVault V2',
      category: 'healthcare',
      description: 'Digital medical records app with role-based access, ICD code search, and document management',
      tech: ['Flutter', 'Provider', 'Excel Export', 'PDF Handling'],
      playStore: 'https://play.google.com/store/apps/details?id=com.medivault.mrd_app_v2',
      appStore: 'https://apps.apple.com/in/app/medivault-v2/id6758072584',
      hasAndroid: true,
      hasIos: true
    },
    {
      id: 4,
      title: 'SmileSync',
      category: 'healthcare',
      description: 'Dental practice management with patient queue, tooth charts, treatment tracking, and prescriptions',
      tech: ['Flutter', 'Provider', 'REST APIs', 'Calendar'],
      playStore: 'https://play.google.com/store/apps/details?id=com.subharti.smilesyncs',
      hasAndroid: true,
      hasIos: false
    },
    {
      id: 5,
      title: 'ICU Insight',
      category: 'healthcare',
      description: 'ICU monitoring platform with live vitals dashboards, camera streaming, and emergency alerts',
      tech: ['Flutter', 'Provider', 'WebView', 'fl_chart'],
      playStore: 'https://play.google.com/store/apps/details?id=com.cssh.icuinsight',
      hasAndroid: true,
      hasIos: false
    },
    {
      id: 6,
      title: 'Acknowledgement Book',
      category: 'enterprise',
      description: 'Digital document tracking with OTP login, QR generation/scanning, and bulk PDF export',
      tech: ['Flutter', 'Provider', 'QR Scanner', 'PDF Generation'],
      playStore: 'https://play.google.com/store/apps/details?id=com.subharti.peonbook',
      appStore: 'https://apps.apple.com/in/app/acknowledgement-book/id6743952653',
      hasAndroid: true,
      hasIos: true
    },
    {
      id: 7,
      title: 'Marshmallow',
      category: 'commerce',
      description: 'Multi-shop food ordering platform with geolocation, Razorpay payments, and admin dashboard',
      tech: ['Flutter', 'Provider', 'Razorpay', 'Geolocation'],
      playStore: 'https://play.google.com/store/apps/details?id=subharti.marshmallow',
      hasAndroid: true,
      hasIos: false
    }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <section className="portfolio" id="portfolio">
      <div className="container">
        <div className="section-header">
          <h2>Our Portfolio</h2>
          <p>Production Apps on Play Store & App Store</p>
        </div>

        <div className="portfolio-filters">
          <button 
            className={filter === 'all' ? 'active' : ''} 
            onClick={() => setFilter('all')}
          >
            All Projects
          </button>
          <button 
            className={filter === 'healthcare' ? 'active' : ''} 
            onClick={() => setFilter('healthcare')}
          >
            Healthcare
          </button>
          <button 
            className={filter === 'education' ? 'active' : ''} 
            onClick={() => setFilter('education')}
          >
            Education
          </button>
          <button 
            className={filter === 'enterprise' ? 'active' : ''} 
            onClick={() => setFilter('enterprise')}
          >
            Enterprise
          </button>
          <button 
            className={filter === 'commerce' ? 'active' : ''} 
            onClick={() => setFilter('commerce')}
          >
            Commerce
          </button>
        </div>

        <div className="portfolio-grid">
          {filteredProjects.map(project => (
            <div className="portfolio-card" key={project.id}>
              <div className="portfolio-header">
                <h3>{project.title}</h3>
                <div className="platform-badges">
                  {project.hasAndroid && <FaAndroid className="platform-icon android" />}
                  {project.hasIos && <FaApple className="platform-icon ios" />}
                </div>
              </div>
              <p className="project-description">{project.description}</p>
              <div className="tech-stack">
                {project.tech.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
              <div className="project-links">
                {project.hasAndroid && (
                  <a href={project.playStore} target="_blank" rel="noopener noreferrer" className="store-link">
                    <FaAndroid /> Play Store
                  </a>
                )}
                {project.hasIos && (
                  <a href={project.appStore} target="_blank" rel="noopener noreferrer" className="store-link">
                    <FaApple /> App Store
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
